import React from 'react';
import { Wrapper, Footer, LineChart, DonutChart, CardDevices, CardActivity, CardList, DataTable } from '../../components';

class Dashboard extends React.Component{
    
    constructor(props) {
        super(props);
    
        this.state = {
            dataDonut2: {
                "labels": ["Hip", "Hop", "Hat"],
                "datasets": [
                {
                    "borderWidth": 0,
                    "data": [
                    10,
                    20,
                    60
                  ]
                }
              ]
            },
            dataDonut3: {
                "labels": ["Run", "Pass", "Catch"],
                "datasets": [
                {
                    "backgroundColor": ["red","pink","lime"],
                    "borderWidth": 0,
                    "data": [
                    10,
                    70,
                    5
                  ]
                }
              ]
            },
            donutOptions: {
                cutoutPercentage: (this.props.cutoutPercentage||85),
                legend: {
                    position: "bottom",
                    labels: {
                      pointStyle: "circle",
                      usePointStyle: true
                    }
                }
            }
        };
    }
    
    render(){
        return (
            <Wrapper>
                <main className="flex-fill">
                    <div className="row mt-1 wow fadeInUp" data-wow-delay=".3s">
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters flex-nowrap">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Health</h5>
                                        <h3 className="text-nowrap">99.3%</h3>
                                    </div>
                                    <div className="col bg-primary d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href={'# '} className="nav-link text-white pb-0" title="View details"><span className="d-inline-block lnr lnr-heart"></span></a></h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters flex-nowrap">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Cycles</h5>
                                        <h3>53</h3></div>
                                    <div className="col bg-primary d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href={'# '} className="nav-link text-white pb-0" title="View details"><span className="d-inline-block lnr lnr-history"></span></a></h1></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters flex-nowrap">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Storage</h5>
                                        <h3 className="text-nowrap">69%</h3>
                                    </div>
                                    <div className="col bg-primary d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href={'# '} className="nav-link text-white pb-0" title="View details"><span className="d-inline-block lnr lnr-database"></span></a></h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters flex-nowrap">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Signal</h5>
                                        <h3>4.1</h3></div>
                                    <div className="col bg-primary d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href={'# '} className="nav-link text-white pb-0" title="View details"><i className="lnr lnr-heart-pulse"></i></a></h1></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row wow fadeInUp" data-wow-delay=".5s">
                        <div className="col-xl-3 col-lg-12 py-3 wow fadeInUp" data-wow-delay=".5s">
                            <CardDevices />
                        </div>
                        <div className="col-xl-3 col-lg-12 py-3 wow fadeInUp" data-wow-delay="1s">
                            <CardActivity />
                        </div>
                        <div className="col-xl-6 col-lg-12 py-3">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body p-3 d-flex flex-column">
                                    <h4 className="font-weight-light mb-3">Visits</h4>
                                    <span className="text-center text-muted small">Unique daily visitors in the last week</span>
                                    <div className="mt-auto">
                                        <LineChart />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span className="anchor" id="snapshot"></span>
                    <section className="row">
                        <div className="col-xl py-3">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body">
                                    <div className="h4 m-0">
                                        <i className="float-right lnr lnr-cloud-sync"></i>
                                        Latest Build v1.1.6
                                    </div>
                                    <div>75% complete</div>
                                    <div className="progress my-3">
                                        <div role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" className="progress-bar bg-primary w-75"></div>
                                    </div> <small className="text-muted"><a href="#modalSmall" data-toggle="modal">View build log</a></small></div>
                            </div>
                        </div>
                        <div className="col-xl py-3">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body">
                                    <div className="h4 m-0">
                                        <i className="float-right lnr lnr-database"></i>
                                        24 GB
                                    </div>
                                    <div>Backup in progress...</div>
                                    <div className="progress my-3">
                                        <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" className="progress-bar bg-dark w-25"></div>
                                    </div> <small className="text-muted">Contact the administrator for reports.</small></div>
                            </div>
                        </div>
                    </section>
                    <section className="row">
                        <div className="col-xl-4 col-sm-6 py-3">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    <h4 className="font-weight-light">
                                        <div className="float-right dropdown"><button data-toggle="dropdown" className="btn btn-link p-0 dropdown-toggle"><i className="lnr lnr-cog"></i></button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <button className="dropdown-item">Action</button>
                                                <button className="dropdown-item">Another action</button>
                                            </div>
                                        </div>
                                        Framework
                                    </h4>
                                    <DonutChart ref="donutChart1" options={this.state.donutOptions} className="mt-3 mx-auto" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-sm-6 py-3">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    <h4 className="font-weight-light">
                                        <div className="float-right dropdown"><button data-toggle="dropdown" className="btn btn-link p-0 dropdown-toggle"><i className="lnr lnr-cog"></i></button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <button className="dropdown-item">Action</button>
                                                <button className="dropdown-item">Another action</button>
                                            </div>
                                        </div>
                                        Games
                                    </h4>
                                    <DonutChart ref="donutChart2" options={this.state.donutOptions} data={this.state.dataDonut2} className="mt-3 mx-auto" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-sm-6 py-3 mx-auto">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    <h4 className="font-weight-light">
                                        <div className="float-right dropdown"><button data-toggle="dropdown" className="btn btn-link p-0 dropdown-toggle"><i className="lnr lnr-cog"></i></button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <button className="dropdown-item">Action</button>
                                                <button className="dropdown-item">Another action</button>
                                            </div>
                                        </div> 
                                        Stack
                                    </h4>
                                    <DonutChart ref="donutChart3" options={this.state.donutOptions} data={this.state.dataDonut3} className="mt-3 mx-auto" />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="row">
                        <div className="col py-3">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    <CardList />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="row">
                        <div className="col py-3">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    <DataTable />
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <Footer />
            </Wrapper>
        );
    }
}

export default Dashboard;
